module.exports = __webpack_public_path__ + "img/a2b7ca6eb54945439f0d50642a0807ef.b2202761.png";